import { SPONSORS } from "@/data/site";

export default function SponsorStrip() {
  const items = [...SPONSORS, ...SPONSORS];
  return (
    <div data-testid="sponsor-strip" className="overflow-hidden py-8 bg-black border-y border-rgv-maroon">
      <p className="text-center text-rgv-gray uppercase tracking-[0.3em] text-xs mb-6 font-display">
        Our Partners
      </p>
      <div className="relative w-full overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-16 px-8">
          {items.map((s, i) => (
            <img
              key={`${s.file}-${i}`}
              src={s.src}
              alt={s.name}
              title={s.name}
              className="h-12 sm:h-14 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
